import { z } from 'zod';

export const GetCurationTabsVisibilityServiceRequestSchema = z.object({
  snsTitle: z.string().min(1),
});

export type GetCurationTabsVisibilityServiceRequest = z.infer<
  typeof GetCurationTabsVisibilityServiceRequestSchema
>;

export const GetCurationTabsVisibilityServiceResponseSchema = z.object({
  isVisible: z.boolean(),
});

export type GetCurationTabsVisibilityServiceResponse = z.infer<
  typeof GetCurationTabsVisibilityServiceResponseSchema
>;
